import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, ChartDataLabels);

function ByCollection({ chart_data }) {
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");

  // ✅ Prepare dropdown
  useEffect(() => {
    if (!chart_data || chart_data.length === 0) return;

    const yearList = chart_data.map(item => item.year);

    setYears(yearList);

    // ✅ Default latest (first item)
    setSelectedYear(yearList[0]);

  }, [chart_data]);

  // ✅ Update chart on year change
  useEffect(() => {
    if (!selectedYear) return;

    const selectedData = chart_data.find(
      item => item.year === selectedYear
    );

    if (!selectedData) return;

    const quarters = ["Q1", "Q2", "Q3", "Q4"];

    const valuesRaw = [
      Number(selectedData.Q1 || 0),
      Number(selectedData.Q2 || 0),
      Number(selectedData.Q3 || 0),
      Number(selectedData.Q4 || 0),
    ];

    const total = valuesRaw.reduce((sum, val) => sum + val, 0);

    const percentages = valuesRaw.map((val) =>
      total ? ((val / total) * 100).toFixed(1) : 0
    );

    const valuesInCr = valuesRaw.map((val) => val / 10000000);

    const colors = ["#36A2EB", "#4BC0C0", "#FFCE56", "#FF6384"];

    setData({
      labels: quarters,
      datasets: [
        {
          data: percentages,
          actualData: valuesInCr,
          backgroundColor: colors,
          borderWidth: 0,
        },
      ],
    });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        datalabels: {
          color: "#000",
          anchor: "end",
          align: "end",
          formatter: (value) => (value > 1 ? value + "%" : ""),
          font: {
            weight: "bold",
            size: 12,
          },
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              const actual = context.dataset.actualData[context.dataIndex];
              const percent = context.raw;
              return `${percent}% : ₹ ${actual.toFixed(2)} Cr`;
            },
          },
        },
      },
    });

  }, [selectedYear, chart_data]);

  return (
    <div style={{ width: "100%" }}>

      {/* ✅ Year Dropdown */}
      <div style={{ marginBottom: "10px" }}>
        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
        
        {/* PIE */}
        <div style={{ width: "80%", height: "220px" }}>
          {data?.datasets?.length > 0 && (
            <Pie data={data} options={options} />
          )}
        </div>

        {/* LEGEND */}
        <div style={{ width: "20%", paddingLeft: "20px" }}>
          {data.labels?.map((label, index) => (
            <div key={index} style={{ display: "flex", marginBottom: "8px" }}>
              <div
                style={{
                  width: 14,
                  height: 14,
                  backgroundColor:
                    data.datasets[0].backgroundColor[index],
                  marginRight: 10,
                  borderRadius: 4,
                }}
              />
              <span style={{ fontSize: "12px" }}>{label}</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default ByCollection;